module.exports = __webpack_public_path__ + "img/Botan_Profile.38ae38f8.png";